import { render } from "./FullPageLayout.vue?vue&type=template&id=7d725222"
import script from "./FullPageLayout.vue?vue&type=script&lang=js"
export * from "./FullPageLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__